"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hark_1 = __importDefault(require("hark"));
const ee_ts_1 = require("ee-ts");
const ICE_SERVERS = [{ urls: "stun:stun.l.google.com:19302" }];
class PeerConnection extends ee_ts_1.EventEmitter {
    constructor(peerID, peerUsername, shouldCreateOffer, channel, localStream) {
        super();
        this.audioElement = null;
        this.harker = null;
        this.isSpeaking = false;
        this.peerID = peerID;
        this.peerUsername = peerUsername;
        this.channel = channel;
        this.localStream = localStream;
        this.rtcConnection = new RTCPeerConnection({ iceServers: ICE_SERVERS }
        // { optional: [{ DtlsSrtpKeyAgreement: true }] }
        // /* this will no longer be needed by chrome
        //  * eventually (supposedly), but is necessary
        //  * for now to get firefox to talk to chrome */
        );
        this.rtcConnection.onicecandidate = (event) => {
            if (event.candidate) {
                this.channel.RelayICECandidate.send({
                    peerID,
                    iceCandidate: {
                        sdpMLineIndex: event.candidate.sdpMLineIndex,
                        candidate: event.candidate.candidate,
                    },
                });
            }
        };
        this.rtcConnection.ontrack = (event) => {
            // const audioContext = new AudioContext();
            // const mergerNode = audioContext.createChannelMerger(event.streams.length);
            // event.streams.map((stream, idx) => audioContext.createMediaStreamSource(stream).connect(mergerNode, 0, idx));
            // const dest = audioContext.createMediaStreamDestination();
            // mergerNode.connect(dest);
            this.audioElement = document.createElement("audio");
            // this.audioElement.srcObject = dest.stream;
            this.audioElement.srcObject = event.streams[0];
            this.audioElement.autoplay = true;
            this.audioElement.controls = false;
            this.audioElement.muted = false;
            this.harker = hark_1.default(event.streams[0]);
            this.harker.on("speaking", () => {
                this.isSpeaking = true;
                this.emit("onChange", this.isSpeaking);
            });
            this.harker.on("stopped_speaking", () => {
                this.isSpeaking = false;
                this.emit("onChange", this.isSpeaking);
            });
            document.body.appendChild(this.audioElement);
        };
        this.localStream.getTracks().forEach((track) => {
            this.rtcConnection.addTrack(track, this.localStream);
        });
        if (shouldCreateOffer) {
            // console.log("Creating RTC offer to ", peerID);
            this.rtcConnection
                .createOffer({
                voiceActivityDetection: true,
            })
                .then((localDescription) => __awaiter(this, void 0, void 0, function* () {
                // console.log("Local offer description is: ", localDescription);
                try {
                    yield this.rtcConnection.setLocalDescription(localDescription);
                    this.channel.RelaySessionDescription.send({
                        peerID,
                        sessionDescription: { sdp: localDescription.sdp, type: localDescription.type },
                    });
                }
                catch (e) {
                    alert("Offer setLocalDescription failed!");
                }
            }))
                .catch((e) => {
                alert("Offer setLocalDescription failed!");
            });
        }
    }
    handleSessionDescription(sessionDescription) {
        return __awaiter(this, void 0, void 0, function* () {
            // console.log("Remote description received: ", sessionDescription);
            const peer = this.rtcConnection;
            // TODO: there's a way to type this better so no need to cast, but im lazy and its 1:15am
            const desc = new RTCSessionDescription(sessionDescription);
            try {
                yield peer.setRemoteDescription(desc);
                if (sessionDescription.type === "offer") {
                    // console.log("Creating answer");
                    try {
                        const nextDesc = yield peer.createAnswer();
                        //   console.log("Answer description is: ", nextDesc);
                        try {
                            yield peer.setLocalDescription(nextDesc);
                            this.channel.RelaySessionDescription.send({
                                peerID: this.peerID,
                                sessionDescription: { sdp: nextDesc.sdp, type: nextDesc.type },
                            });
                        }
                        catch (e) {
                            alert("Answer setLocalDescription failed!");
                        }
                    }
                    catch (e) {
                        console.log("Error creating answer: ", e);
                    }
                }
            }
            catch (e) {
                console.log("setRemoteDescription error: ", e);
            }
            // console.log("Description Object: ", desc);
        });
    }
    handleICECandidate(candidate) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.rtcConnection.addIceCandidate(new RTCIceCandidate(candidate));
        });
    }
    close() {
        var _a, _b;
        (_a = this.audioElement) === null || _a === void 0 ? void 0 : _a.remove();
        this.audioElement = null;
        (_b = this.harker) === null || _b === void 0 ? void 0 : _b.stop();
        this.rtcConnection.close();
    }
    getStatus() {
        return {
            username: this.peerUsername,
            speaking: this.isSpeaking,
        };
    }
}
exports.default = PeerConnection;
//# sourceMappingURL=data:application/json;base64,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